import { providers } from "ethers";
import Web3 from "web3";
import config from "../../services/config/homestead.json";

export const ChainId = {
  MAINNET: 1,
  GOERLI: 5,
  BINANCE: 56,
  GNOSIS: 100,
  POLYGON: 137,
  ARBITUM: 42161,
  SEPOLIA: 11155111,
  BASE: 8453,
  BASESEPOLIA: 84532,
};

export const NETWORKS_INFO = {
  [ChainId.MAINNET]: {
    chainId: ChainId.MAINNET,
    name: "Ethereum",
    urlKey: "ethereum",
    dmmSwapUrl: "https://kyberswap.com/",
    subgraphName: "dynamic-amm/dynamic-amm",
    balancerSubgraphUrl:
      "https://api.studio.thegraph.com/query/77016/vault-mainnet/version/latest",
    verifiedWalletSubgraphUrl:
      "https://api.studio.thegraph.com/query/77016/wallet-mainnet/version/latest",
    kyberSubgraphUrl:
      "https://api.thegraph.com/subgraphs/name/kybernetwork/kyberswap-exchange-ethereum",
    subgraphUrls: [
      "https://api.thegraph.com/subgraphs/name/kybernetwork/kyberswap-exchange-ethereum",
    ],
    lidoAddress: "0xae7ab96520DE3A18E5e111B5EaAb095312D7fE84",
    verifiedLidoRewardAddress: "0x19836182a3786CD592523cAB7445325be26c3334",
    subgraphBlockUrl:
      "https://api.thegraph.com/subgraphs/name/dynamic-amm/ethereum-blocks-ethereum",
    etherscanUrl: "https://etherscan.io",
    kncAddress: "0xdeFA4e8a7bcBA345F687a2f1456F5Edd9CE97202",
    wethAddress: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
    defaultStartTime: 1620201600,
    nativeTokenSymbol: "ETH",
    nativeTokenWrappedName: "Ether (Wrapped)",
    etherscanLinkText: "Etherscan",
    tokensListUrl:
      "https://raw.githubusercontent.com/KyberNetwork/ks-assets/main/tokenLists/ethereum.tokenlist.json",
    factoryAddress: "0x833e4083B7ae46CeA85695c4f7ed25CDAd8886dE",
    usdc: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
    spotTokens: { usdc: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48" },
    ustbAddress: "0x43415eB6ff9DB7E26A15b704e7A3eDCe97d31C4e",
    ustbRedeemer: "0x4c21B7577C8FE8b0B0669165ee7C8f67fa1454Cf",
  },
  [ChainId.GOERLI]: {
    chainId: ChainId.GOERLI,
    name: "Goerli",
    urlKey: "ethereum",
    dmmSwapUrl: "https://kyberswap.com/",
    subgraphName: "dynamic-amm/dynamic-amm",
    balancerSubgraphUrl:
      "https://api.thegraph.com/subgraphs/name/verified-network/balancer",
    verifiedWalletSubgraphUrl:
      "https://api.thegraph.com/subgraphs/name/verified-network/payments",
    kyberSubgraphUrl:
      "https://api.thegraph.com/subgraphs/name/kybernetwork/kyberswap-exchange-ethereum",
    subgraphUrls: [
      "https://api.thegraph.com/subgraphs/name/kybernetwork/kyberswap-exchange-ethereum",
    ],
    subgraphBlockUrl:
      "https://api.thegraph.com/subgraphs/name/dynamic-amm/ethereum-blocks-ethereum",
    etherscanUrl: "https://etherscan.io",
    kncAddress: "0xdeFA4e8a7bcBA345F687a2f1456F5Edd9CE97202",
    wethAddress: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
    defaultStartTime: 1620201600,
    nativeTokenSymbol: "ETH",
    nativeTokenWrappedName: "Ether (Wrapped)",
    etherscanLinkText: "Etherscan",
    tokensListUrl:
      "https://raw.githubusercontent.com/KyberNetwork/ks-assets/main/tokenLists/ethereum.tokenlist.json",
    factoryAddress: "0x833e4083B7ae46CeA85695c4f7ed25CDAd8886dE",
  },
  [ChainId.BINANCE]: {
    chainId: ChainId.BINANCE,
    name: "BINANCE",
    urlKey: "ethereum",
    dmmSwapUrl: "https://kyberswap.com/",
    subgraphName: "dynamic-amm/dynamic-amm",
    balancerSubgraphUrl:
      "https://api.thegraph.com/subgraphs/name/verified-network/vault-bsc",
    verifiedWalletSubgraphUrl:
      "https://api.thegraph.com/subgraphs/name/verified-network/wallet-bsc",
    kyberSubgraphUrl:
      "https://api.thegraph.com/subgraphs/name/kybernetwork/kyberswap-exchange-ethereum",
    etherscanUrl: "https://etherscan.io",
    kncAddress: "0xdeFA4e8a7bcBA345F687a2f1456F5Edd9CE97202",
    wethAddress: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
    defaultStartTime: 1620201600,
    nativeTokenSymbol: "ETH",
    nativeTokenWrappedName: "Ether (Wrapped)",
    etherscanLinkText: "Etherscan",
    tokensListUrl:
      "https://raw.githubusercontent.com/KyberNetwork/ks-assets/main/tokenLists/ethereum.tokenlist.json",
    factoryAddress: "0x833e4083B7ae46CeA85695c4f7ed25CDAd8886dE",
  },
  [ChainId.GNOSIS]: {
    chainId: ChainId.GNOSIS,
    name: "GNOSIS",
    urlKey: "ethereum",
    dmmSwapUrl: "https://kyberswap.com/",
    subgraphName: "dynamic-amm/dynamic-amm",
    balancerSubgraphUrl:
      "https://api.studio.thegraph.com/query/77016/vault-gnosis/version/latest",
    verifiedWalletSubgraphUrl:
      "https://api.studio.thegraph.com/query/77016/wallet-gnosis/version/latest",
    kyberSubgraphUrl:
      "https://api.thegraph.com/subgraphs/name/kybernetwork/kyberswap-exchange-ethereum",
    etherscanUrl: "https://etherscan.io",
    kncAddress: "0xdeFA4e8a7bcBA345F687a2f1456F5Edd9CE97202",
    wethAddress: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
    defaultStartTime: 1620201600,
    nativeTokenSymbol: "XDAI",
    nativeTokenWrappedName: "Ether (Wrapped)",
    etherscanLinkText: "Etherscan",
    tokensListUrl:
      "https://raw.githubusercontent.com/KyberNetwork/ks-assets/main/tokenLists/ethereum.tokenlist.json",
    factoryAddress: "0x833e4083B7ae46CeA85695c4f7ed25CDAd8886dE",
  },
  [ChainId.BASE]: {
    chainId: ChainId.BASE,
    name: "Base Mainnet",
    urlKey: "ethereum",
    dmmSwapUrl: "https://kyberswap.com/",
    subgraphName: "dynamic-amm/dynamic-amm",
    balancerSubgraphUrl: `https://gateway.thegraph.com/api/${config.keys.subgraph}/subgraphs/id/HESgHTG2RE8F74MymKrdXKJw2u4s8YBJgbCjHuzhpXeC`,
    verifiedWalletSubgraphUrl: `https://gateway.thegraph.com/api/${config.keys.subgraph}/subgraphs/id/2aGD2WDR6ncrTvGU4wEaME2Ywke1ookuNucMNJmcnrz5`,
    kyberSubgraphUrl:
      "https://api.thegraph.com/subgraphs/name/kybernetwork/kyberswap-exchange-ethereum",
    subgraphUrls: [
      "https://api.thegraph.com/subgraphs/name/kybernetwork/kyberswap-exchange-ethereum",
    ],
    etherscanUrl: "https://basescan.org",
    kncAddress: "0xdeFA4e8a7bcBA345F687a2f1456F5Edd9CE97202",
    wethAddress: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
    defaultStartTime: 1620201600,
    nativeTokenSymbol: "ETH",
    nativeTokenWrappedName: "Ether (Wrapped)",
    etherscanLinkText: "Basescan",
    tokensListUrl:
      "https://raw.githubusercontent.com/KyberNetwork/ks-assets/main/tokenLists/ethereum.tokenlist.json",
    factoryAddress: "0x833e4083B7ae46CeA85695c4f7ed25CDAd8886dE",
    spotTokens: {},
    usdc: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
    PriceFeeds: {
      "USDC/USD": "0x7e860098F58bBFC8648a4311b374B1D669a2bc6B",
      "ETH/USD": "0x71041dddad3595F9CEd3DcCFBe3D1F4b0a16Bb70",
    },
  },
  [ChainId.BASESEPOLIA]: {
    chainId: ChainId.BASESEPOLIA,
    name: "Base Sepolia",
    urlKey: "ethereum",
    dmmSwapUrl: "https://kyberswap.com/",
    subgraphName: "dynamic-amm/dynamic-amm",
    balancerSubgraphUrl: "",
    verifiedWalletSubgraphUrl:
      "https://api.studio.thegraph.com/query/77016/wallet-arbitrum/version/latest",
    kyberSubgraphUrl:
      "https://api.thegraph.com/subgraphs/name/kybernetwork/kyberswap-exchange-ethereum",
    subgraphUrls: [
      "https://api.thegraph.com/subgraphs/name/kybernetwork/kyberswap-exchange-ethereum",
    ],
    etherscanUrl: "https://sepolia.basescan.org",
    kncAddress: "0xdeFA4e8a7bcBA345F687a2f1456F5Edd9CE97202",
    wethAddress: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
    defaultStartTime: 1620201600,
    nativeTokenSymbol: "ETH",
    nativeTokenWrappedName: "Ether (Wrapped)",
    etherscanLinkText: "Basescan",
    tokensListUrl:
      "https://raw.githubusercontent.com/KyberNetwork/ks-assets/main/tokenLists/ethereum.tokenlist.json",
    factoryAddress: "0x833e4083B7ae46CeA85695c4f7ed25CDAd8886dE",
  },
  [ChainId.POLYGON]: {
    chainId: ChainId.POLYGON,
    name: "Polygon",
    urlKey: "ethereum",
    dmmSwapUrl: "https://kyberswap.com/",
    subgraphName: "dynamic-amm/dynamic-amm",
    balancerSubgraphUrl:
      "https://api.thegraph.com/subgraphs/name/verified-network/vault-matic",
    verifiedWalletSubgraphUrl:
      "https://api.thegraph.com/subgraphs/name/verified-network/wallet-matic",
    kyberSubgraphUrl:
      "https://api.thegraph.com/subgraphs/name/kybernetwork/kyberswap-exchange-ethereum",
    etherscanUrl: "https://etherscan.io",
    kncAddress: "0xdeFA4e8a7bcBA345F687a2f1456F5Edd9CE97202",
    wethAddress: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
    defaultStartTime: 1620201600,
    nativeTokenSymbol: "ETH",
    nativeTokenWrappedName: "Ether (Wrapped)",
    etherscanLinkText: "Etherscan",
    tokensListUrl:
      "https://raw.githubusercontent.com/KyberNetwork/ks-assets/main/tokenLists/ethereum.tokenlist.json",
    factoryAddress: "0x833e4083B7ae46CeA85695c4f7ed25CDAd8886dE",
  },
  [ChainId.ARBITUM]: {
    chainId: ChainId.ARBITUM,
    name: "ARBITUM",
    urlKey: "ethereum",
    dmmSwapUrl: "https://kyberswap.com/",
    subgraphName: "dynamic-amm/dynamic-amm",
    balancerSubgraphUrl:
      "https://api.thegraph.com/subgraphs/name/verified-network/vault-arbitrum",
    verifiedWalletSubgraphUrl:
      "https://api.thegraph.com/subgraphs/name/verified-network/wallet-arbitrum",
    kyberSubgraphUrl:
      "https://api.thegraph.com/subgraphs/name/kybernetwork/kyberswap-exchange-ethereum",
    subgraphUrls: [
      "https://api.thegraph.com/subgraphs/name/kybernetwork/kyberswap-exchange-ethereum",
    ],
    etherscanUrl: "https://etherscan.io",
    kncAddress: "0xdeFA4e8a7bcBA345F687a2f1456F5Edd9CE97202",
    wethAddress: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
    defaultStartTime: 1620201600,
    nativeTokenSymbol: "ETH",
    nativeTokenWrappedName: "Ether (Wrapped)",
    etherscanLinkText: "Etherscan",
    tokensListUrl:
      "https://raw.githubusercontent.com/KyberNetwork/ks-assets/main/tokenLists/ethereum.tokenlist.json",
    factoryAddress: "0x833e4083B7ae46CeA85695c4f7ed25CDAd8886dE",
  },
  [ChainId.SEPOLIA]: {
    chainId: ChainId.SEPOLIA,
    name: "SEPOLIA",
    urlKey: "ethereum",
    dmmSwapUrl: "https://kyberswap.com/",
    subgraphName: "dynamic-amm/dynamic-amm",
    balancerSubgraphUrl: `https://gateway.thegraph.com/api/${config.keys.subgraph}/subgraphs/id/BZYwDU6CtLq1GBwCaGUZBU4KcQk9CAtPDkEY4LAKfoJN`,

    verifiedWalletSubgraphUrl: `https://gateway.thegraph.com/api/${config.keys.subgraph}/subgraphs/id/6Qxzqb6J12vxKqgaGmCopuQH6bzGhAzYz45bRzPs2EiG`,
    // "https://api.studio.thegraph.com/query/77016/test-wallet/version/latest",
    kyberSubgraphUrl:
      "https://api.thegraph.com/subgraphs/name/kybernetwork/kyberswap-exchange-ethereum",
    subgraphUrls: [
      "https://api.thegraph.com/subgraphs/name/kybernetwork/kyberswap-exchange-ethereum",
    ],
    etherscanUrl: "https://etherscan.io",
    kncAddress: "0xdeFA4e8a7bcBA345F687a2f1456F5Edd9CE97202",
    wethAddress: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
    defaultStartTime: 1620201600,
    nativeTokenSymbol: "ETH",
    nativeTokenWrappedName: "Ether (Wrapped)",
    etherscanLinkText: "Etherscan",
    tokensListUrl:
      "https://raw.githubusercontent.com/KyberNetwork/ks-assets/main/tokenLists/ethereum.tokenlist.json",
    factoryAddress: "0x833e4083B7ae46CeA85695c4f7ed25CDAd8886dE",
    lidoAddress: "0x3e3FE7dBc6B4C189E7128855dD526361c49b40Af",
    verifiedLidoRewardAddress: "0x19836182a3786CD592523cAB7445325be26c3334",
    apAddresses: {
      CERTFEngine: "0x452eFEE6D644BA3dC6C3271a1d96D90b7dA01237",
      CERTFRegistry: "0x4E11Ee9721A7fCa8d91c82B1e27E5E89048d0E2B",
      DataRegistryProxy: "0xC10B63D47027cb68d51dC1813EF6e4b697939987",
      CERTFActor: "0x8C182dA779Ed9012bDc1052B980D40154467d7d3",
      DvPSettlement: "0xd7936834Ca91f0ab3eBC90d5B9c09f813184F5Ad",
      ANNEngine: "0x9377EB83df636E0f529eb8ee5967A41168D53eAA",
      CECEngine: "0x6b67FAf31b8409d34d7378F12f68D97dDEa4f466",
      CEGEngine: "0x35fe1e022216515eD7D471fa7C9c3567489540E4",
      COLLAEngine: "0xaaF60978e4699E9eD923747fef7Ce6A717Fe4099",
      PAMEngine: "0x033fdf85cCDeEd0Ef7C7b763c880fd3E307eAd8b",
      STKEngine: "0xa639FCb3def7A101184E466c93394D94dD7724b0",
      ANNRegistry: "0x2077562A04E0AcBf1e87598AC23615FCEDbbB36b",
      CECRegistry: "0x36edB21C596f761EEE7B06caE95f7B591C572324",
      CEGRegistry: "0x66569F77e73d4555479eD391A309119c47328115",
      COLLARegistry: "0xd7860029C3C7691DE7f852178F6511735e323e5b",
      PAMRegistry: "0x6529B57fD4D4E61F78B05030cbF9B9fe41Bf417f",
      STKRegistry: "0xc368717a0c864173Da73093F51E7c00539caF411",
      ANNActor: "0x7Afb32e00b511847F0D69CCB79Ba30d103A33a23",
      CECActor: "0xE3AB343aE624C753b6EfD6989A0001F59AB68128",
      CEGActor: "0x7C4043557C5465c7D4C0753f7B596783d7555f8d",
      COLLAActor: "0xe8e655A54B4840C93dA6Dac2ad29f2dDfF0231f7",
      PAMActor: "0xFeA6Ac7394AB4715101b15FaaB9AFd18a7F0Ca4b",
      STKActor: "0xa1b46A9C5a0C02771813Ae9C4413111819C3A72D",
      Custodian: "0x937b660A1d9724a9b419D5aaAeb2a3B3c4341C25",
    },
    usdc: "0x1c7D4B196Cb0C7B01d743Fbc6116a902379C7238",
    spotTokens: { usdc: "0x1c7D4B196Cb0C7B01d743Fbc6116a902379C7238" },
    ustbAddress: "0x39727692cF58137Bd8c401eFE87Cc8A190D62ead",
    ustbRedeemer: "0xd33d340CdbEf8E879C827199BD7D9705b21e18c9",
    PriceFeeds: {
      "USDC/USD": "0xA2F78ab2355fe2f984D808B5CeE7FD0A93D5270E",
      "ETH/USD": "0x694AA1769357215DE4FAC081bf1f309aDC325306",
    },
  },
};

export const getProviderNetwork = (chain) => {
  return {
    chainId: chain?.id,
    name: chain?.name,
    ensAddress: chain?.contracts?.ensRegistry?.address,
  };
};

export const getProvider = (transport, network) => {
  return new providers.Web3Provider(transport, network);
};

export const getWeb3 = (transport) => {
  if (transport.type === "fallback") {
    return new Web3(transport.transports[0].value?.url);
  }
  return new Web3(transport);
};
